//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/Object.js";
import "../Layout2d/Layout2d.ComponentCollection.js";
let d=[[],[[["parentObject","numberOfOrders","ordersNames"],"GetAvailableOrdersNames",{},1,0],[["parentObject","orderName"],"IsSystemOrder",{R_:{isSystem:''}},2,0],[["parentObject"],"GetCurrentOrderName",{R_:{orderName:''}},1,0],[["parentObject","orderName"],"ApplyOrder",{},2,0],[["parentObject","newOrderName","objectsInOrder"],"CreateNewOrder",{},3,0],[["parentObject","orderName","newOrderName"],"RenameOrder",{},3,0],[["parentObject","newOrderName"],"DeleteOrder",{},2,0],[["parentObject","objectsInOrder"],"Reorder",{},2,0]],[]];
SPLM.Drawings.OrderManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Drawings.OrderManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;